var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.55749 12.8537C5.55749 20.5721 11.8506 26.8555 19.581 26.8555C21.5816 26.8555 23.5239 26.4288 25.2914 25.6531C22.7664 27.9996 19.3868 29.3959 15.7741 29.3959C8.04368 29.3959 1.75057 23.1126 1.75057 15.3942C1.75057 9.69261 5.18845 4.78617 10.0831 2.59475C7.30558 5.17403 5.57693 8.83931 5.57693 12.8537H5.55749ZM17.7553 0.267587C17.0949 0.190014 16.4345 0.131836 15.7547 0.131836C7.30558 0.131836 0.449219 6.97758 0.449219 15.4136C0.449219 23.8495 7.30558 30.6953 15.7547 30.6953C22.8247 30.6953 28.7488 25.9052 30.4969 19.4085C28.2632 23.1126 24.2232 25.6143 19.5616 25.6143C12.5304 25.6143 6.82001 19.9127 6.82001 12.8925C6.82001 6.49276 11.5787 1.19845 17.7358 0.306374L17.7553 0.267587Z",
    fill: "#FD4319"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoon);
export default __webpack_public_path__ + "static/media/Moon.dc3ecc7ace89f8c71595b012f0dfe15d.svg";
export { ForwardRef as ReactComponent };